"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeHeightAvatarBase = '2.5rem';
exports.SizeHeightAvatarExtraSmall = '2rem';
exports.SizeHeightAvatarExtraLarge = '4rem';
exports.SizeHeightAvatarSmall = '2.5rem';
exports.SizeHeightAvatarMedium = '3rem';
exports.SizeHeightAvatarLarge = '3.5rem';
exports.SizeHeightAvatarIconBase = '1.5rem';
exports.SizeHeightAvatarIconExtraSmall = '1.25rem';
exports.SizeHeightAvatarIconExtraLarge = '2.25rem';
exports.SizeHeightAvatarIconSmall = '1.5rem';
exports.SizeHeightAvatarIconMedium = '1.75rem';
exports.SizeHeightAvatarIconLarge = '2rem';
exports.SizeHeightButtonDefaultBase = '2.25rem';
exports.SizeHeightButtonDefaultMedium = '3rem';
exports.SizeHeightButtonDefaultLarge = '3.75rem';
exports.SizeHeightButtonContainedPrice = '4rem';
exports.SizeHeightButtonIconBase = '2rem';
exports.SizeHeightButtonIconLarge = '2.5rem';
exports.SizeHeightButtonIconFloating = '3rem';
exports.SizeHeightButtonIconFloatingLarge = '4.5rem';
exports.SizeHeightIconButtonDefaultBase = '1rem';
exports.SizeHeightIconButtonDefaultLarge = '1.5rem';
exports.SizeHeightIconButtonIconBase = '1.5rem';
exports.SizeHeightIconButtonIconLarge = '2rem';
exports.SizeHeightIconSmall = '1rem';
exports.SizeHeightIconMedium = '1.5rem';
exports.SizeHeightIconLarge = '2rem';
exports.SizeHeightCheckboxBase = '1.25rem';
exports.SizeHeightChip = '2.25rem';
exports.SizeHeightInputBase = '3rem';
exports.SizeHeightListIconBase = '3rem';
exports.SizeHeightPaymentIconSmall = '1.5rem';
exports.SizeHeightPaymentIconMedium = '2rem';
exports.SizeHeightPaymentIconLarge = '3rem';
exports.SizeHeightRadioBase = '1.25rem';
exports.SizeHeightRadioCheckedCircle = '0.5rem';
exports.SizeHeightSegmentBase = '2rem';
exports.SizeHeightSwitchCircleSmall = '1.5rem';
exports.SizeHeightSwitchCircleMedium = '2rem';
exports.SizeHeightSwitchTrackSmall = '1rem';
exports.SizeHeightSwitchTrackMedium = '1.5rem';
exports.SizeHeightTabsBase = '3rem';
exports.SizeHeightTagMedium = '1.5rem';
exports.SizeHeightTagLarge = '2rem';
exports.SizeHeightTooltipArrowDialogBase = '0.875rem';
exports.SizeWidthAvatarBase = '2.5rem';
exports.SizeWidthAvatarExtraSmall = '2rem';
exports.SizeWidthAvatarExtraLarge = '4rem';
exports.SizeWidthAvatarSmall = '2.5rem';
exports.SizeWidthAvatarMedium = '3rem';
exports.SizeWidthAvatarLarge = '3.5rem';
exports.SizeWidthAvatarIconBase = '1.5rem';
exports.SizeWidthAvatarIconExtraSmall = '1.25rem';
exports.SizeWidthAvatarIconExtraLarge = '2.25rem';
exports.SizeWidthAvatarIconSmall = '1.5rem';
exports.SizeWidthAvatarIconMedium = '1.75rem';
exports.SizeWidthAvatarIconLarge = '2rem';
exports.SizeWidthButtonDefaultBase = '4.75rem';
exports.SizeWidthButtonDefaultLarge = '20.5rem';
exports.SizeWidthButtonDefaultFluid = '4.75rem';
exports.SizeWidthButtonIconBase = '2rem';
exports.SizeWidthButtonIconLarge = '2.5rem';
exports.SizeWidthButtonIconFloating = '3rem';
exports.SizeWidthButtonIconFloatingLarge = '4.5rem';
exports.SizeWidthIconButtonDefaultBase = '1rem';
exports.SizeWidthIconButtonDefaultLarge = '1.5rem';
exports.SizeWidthIconButtonIconBase = '1.5rem';
exports.SizeWidthIconButtonIconLarge = '2rem';
exports.SizeWidthIconSmall = '1rem';
exports.SizeWidthIconMedium = '1.5rem';
exports.SizeWidthIconLarge = '2rem';
exports.SizeWidthCheckboxBase = '1.25rem';
exports.SizeWidthInputOtpSingle = '3rem';
exports.SizeWidthInputOtpWrapper = '3.5rem';
exports.SizeWidthListIconBase = '3rem';
exports.SizeWidthModalDesktop = '26.25rem';
exports.SizeWidthModalMobile = '20.5rem';
exports.SizeWidthNotificationBannerFloatingDesktop = '25rem';
exports.SizeWidthPaymentIconSmall = '1.5rem';
exports.SizeWidthPaymentIconMedium = '2rem';
exports.SizeWidthPaymentIconLarge = '3rem';
exports.SizeWidthRadioBase = '1.25rem';
exports.SizeWidthRadioCheckedCircle = '0.5rem';
exports.SizeWidthSwitchCircleSmall = '1.5rem';
exports.SizeWidthSwitchCircleMedium = '2rem';
exports.SizeWidthSwitchTrackSmall = '2.5rem';
exports.SizeWidthSwitchTrackMedium = '3rem';
exports.SizeWidthTabsBase = '7.5rem';
exports.SizeWidthToastBase = '20.5rem';
exports.SizeWidthTooltipBase = '15.5rem';
exports.SizeWidthTooltipArrowDialogBase = '0.875rem';
exports.SizeMarginAvatarLeftBase = '0.5rem';
exports.SizeMarginAvatarLeftExtraSmall = '0.5rem';
exports.SizeMarginAvatarLeftExtraLarge = '1rem';
exports.SizeMarginAvatarLeftSmall = '0.5rem';
exports.SizeMarginAvatarLeftMedium = '0.75rem';
exports.SizeMarginAvatarLeftLarge = '0.75rem';
exports.SizeMarginIconButtonIconRightBase = '0.25rem';
exports.SizeMarginIconButtonIconRightLarge = '0.5rem';
exports.SizeMarginChipBase = '0.5rem';
exports.SizeMarginErrorBannerIcon = '0.5rem';
exports.SizeMarginErrorBannerAction = '0.5rem';
exports.SizeMarginInputBottom = '1rem';
exports.SizeMarginListSmall = '0.25rem';
exports.SizeMarginListMedium = '0.5rem';
exports.SizeMarginNotificationBannerIcon = '0.5rem';
exports.SizeMarginNotificationBannerMobile = '1rem';
exports.SizePaddingButtonDefaultBase = '1rem';
exports.SizePaddingButtonDefaultMedium = '1.25rem';
exports.SizePaddingButtonDefaultLarge = '1.5rem';
exports.SizePaddingChipX = '0.75rem';
exports.SizePaddingChipY = '0.5rem';
exports.SizePaddingDialogBase = '1rem';
exports.SizePaddingErrorBannerMedium = '0.5rem';
exports.SizePaddingErrorBannerHigh = '0.75rem';
exports.SizePaddingInputBase = '0.75rem';
exports.SizePaddingInputOtpSingleX = '0.25rem';
exports.SizePaddingInputOtpSingleY = '0rem';
exports.SizePaddingListBase = '1rem';
exports.SizePaddingListSmall = '0.25rem';
exports.SizePaddingListMedium = '0.75rem';
exports.SizePaddingModalDesktop = '1.5rem';
exports.SizePaddingModalMobile = '1rem';
exports.SizePaddingNotificationBannerBase = '0.75rem';
exports.SizePaddingTabsBase = '0.75rem';
exports.SizePaddingToastBase = '0.75rem';
exports.SizeFontButtonDefaultBase = '0.875rem';
exports.SizeFontButtonDefaultMedium = '1rem';
exports.SizeFontButtonDefaultLarge = '1.125rem';
exports.SizeFontButtonContainedPrice = '1.4375rem';
exports.SizeFontErrorBannerMedium = '0.75rem';
exports.SizeFontErrorBannerHigh = '0.875rem';
exports.SizeFontInputBase = '1rem';
exports.SizeFontLinkSmall = '0.75rem';
exports.SizeFontLinkMedium = '0.875rem';
exports.SizeFontLinkLarge = '1rem';
exports.SizeFontPointsBase = '0.875rem';
exports.SizeFontTagBase = '0.75rem';
exports.SizeFontTooltipBase = '0.875rem';
exports.SizeFontTypographyH1 = '2rem';
exports.SizeFontTypographyH2 = '1.8125rem';
exports.SizeFontTypographyH3 = '1.4375rem';
exports.SizeFontTypographyH4 = '1.25rem';
exports.SizeFontTypographyH5 = '1.125rem';
exports.SizeFontTypographyH6 = '1rem';
exports.SizeFontTypographySubhead1 = '0.875rem';
exports.SizeFontTypographySubhead2 = '0.75rem';
exports.SizeFontTypographyBody1 = '1.25rem';
exports.SizeFontTypographyBody2 = '1rem';
exports.SizeFontTypographyBody3 = '0.875rem';
exports.SizeFontTypographyBody4 = '0.75rem';
exports.SizeFontTypographyPrice1 = '1.4375rem';
exports.SizeFontTypographyPrice2 = '1.25rem';
exports.SizeFontTypographyPrice3 = '1rem';
exports.SizeFontTypographyPrice4 = '0.875rem';
exports.SizeFontTypographyPrice5 = '0.75rem';
exports.SizeFontTypographyTitleXxl = '2rem';
exports.SizeFontTypographyTitleXl = '1.8125rem';
exports.SizeFontTypographyTitleL = '1.4375rem';
exports.SizeFontTypographyTitleM = '1.25rem';
exports.SizeFontTypographyTitleS = '1.125rem';
exports.SizeFontTypographyTitleXs = '1rem';
exports.SizeFontTypographyBodyLBold = '1.125rem';
exports.SizeFontTypographyBodyLRegular = '1.125rem';
exports.SizeFontTypographyBodyMBold = '1rem';
exports.SizeFontTypographyBodyM = '1rem';
exports.SizeFontTypographyBodySBold = '0.875rem';
exports.SizeFontTypographyBodyS = '0.875rem';
exports.SizeFontTypographyCaption1Regular = '0.75rem';
exports.SizeFontTypographyCaption1Bold = '0.75rem';
exports.SizeFontTypographyCaption2Regular = '0.6875rem';
exports.SizeFontTypographyCaption2Bold = '0.6875rem';
exports.SizeFontTypographyPriceXl = '1.8125rem';
exports.SizeFontTypographyPriceL = '1.4375rem';
exports.SizeFontTypographyPriceM = '1.25rem';
exports.SizeFontTypographyPriceS = '1.125rem';
exports.SizeFontTypographyPriceXs = '1rem';
exports.SizeFontTypographyPriceXxs = '0.875rem';
exports.SizeFontXxl = '2rem';
exports.SizeFontXl = '1.8125rem';
exports.SizeFontL = '1.4375rem';
exports.SizeFontM = '1.25rem';
exports.SizeFontSm = '1.125rem';
exports.SizeFontS = '1rem';
exports.SizeFontXs = '0.875rem';
exports.SizeFontXxs = '0.75rem';
exports.SizeFontXxxs = '0.6875rem';
exports.SizeLineHeightButtonDefaultBase = '1.25rem';
exports.SizeLineHeightButtonDefaultMedium = '1.5rem';
exports.SizeLineHeightButtonDefaultLarge = '1.75rem';
exports.SizeLineHeightButtonContainedPrice = '2rem';
exports.SizeLineHeightErrorBannerMedium = '1rem';
exports.SizeLineHeightErrorBannerHigh = '1.25rem';
exports.SizeLineHeightInputBase = '1.5rem';
exports.SizeLineHeightLinkSmall = '1rem';
exports.SizeLineHeightLinkMedium = '1.25rem';
exports.SizeLineHeightLinkLarge = '1.5rem';
exports.SizeLineHeightPointsBase = '1.25rem';
exports.SizeLineHeightTagBase = '1rem';
exports.SizeLineHeightTooltipBase = '1.43rem';
exports.SizeLineHeightTypographyH1 = '2.75rem';
exports.SizeLineHeightTypographyH2 = '2.5rem';
exports.SizeLineHeightTypographyH3 = '2rem';
exports.SizeLineHeightTypographyH4 = '1.75rem';
exports.SizeLineHeightTypographyH5 = '1.75rem';
exports.SizeLineHeightTypographyH6 = '1.5rem';
exports.SizeLineHeightTypographySubhead1 = '1.25rem';
exports.SizeLineHeightTypographySubhead2 = '1rem';
exports.SizeLineHeightTypographyBody1 = '1.75rem';
exports.SizeLineHeightTypographyBody2 = '1.5rem';
exports.SizeLineHeightTypographyBody3 = '1.25rem';
exports.SizeLineHeightTypographyBody4 = '1rem';
exports.SizeLineHeightTypographyPrice1 = '2rem';
exports.SizeLineHeightTypographyPrice2 = '1.75rem';
exports.SizeLineHeightTypographyPrice3 = '1.5rem';
exports.SizeLineHeightTypographyPrice4 = '1.25rem';
exports.SizeLineHeightTypographyPrice5 = '1rem';
exports.SizeLineHeightTypographyTitleXxl = '2.75rem';
exports.SizeLineHeightTypographyTitleXl = '2.5rem';
exports.SizeLineHeightTypographyTitleL = '2rem';
exports.SizeLineHeightTypographyTitleM = '1.75rem';
exports.SizeLineHeightTypographyTitleS = '1.75rem';
exports.SizeLineHeightTypographyTitleXs = '1.25rem';
exports.SizeLineHeightTypographyBodyLBold = '1.75rem';
exports.SizeLineHeightTypographyBodyLRegular = '1.75rem';
exports.SizeLineHeightTypographyBodyMBold = '1.5rem';
exports.SizeLineHeightTypographyBodyM = '1.5rem';
exports.SizeLineHeightTypographyBodySBold = '1.25rem';
exports.SizeLineHeightTypographyBodyS = '1.25rem';
exports.SizeLineHeightTypographyCaption1Regular = '1rem';
exports.SizeLineHeightTypographyCaption1Bold = '1rem';
exports.SizeLineHeightTypographyCaption2Regular = '1rem';
exports.SizeLineHeightTypographyCaption2Bold = '1rem';
exports.SizeLineHeightTypographyPriceXl = '2.25rem';
exports.SizeLineHeightTypographyPriceL = '1.75rem';
exports.SizeLineHeightTypographyPriceM = '1.5rem';
exports.SizeLineHeightTypographyPriceS = '1.25rem';
exports.SizeLineHeightTypographyPriceXs = '1.25rem';
exports.SizeLineHeightTypographyPriceXxs = '1rem';
exports.SizeLineHeightXxl = '2.75rem';
exports.SizeLineHeightXl = '2.5rem';
exports.SizeLineHeightL2 = '2.25rem';
exports.SizeLineHeightL = '2rem';
exports.SizeLineHeightM = '1.75rem';
exports.SizeLineHeightSm = '1.75rem';
exports.SizeLineHeightS = '1.5rem';
exports.SizeLineHeightXs = '1.25rem';
exports.SizeLineHeightXxs = '1rem';
exports.SizeBorderWeightButtonOutlinedBase = '0.0625rem';
exports.SizeBorderRadiusButtonBase = '0.25rem';
exports.SizeBorderRadiusCheckboxBase = '0.125rem';
exports.SizeBorderRadiusChip = '3.125rem';
exports.SizeBorderRadiusInputBase = '0.25rem';
exports.SizeBorderRadiusModalBase = '0.5rem';
exports.SizeBorderRadiusSegmentBase = '0.25rem';
exports.SizeBorderRadiusSwitchTrackBase = '1rem';
exports.SizeBorderRadiusTagMedium = '0.75rem';
exports.SizeBorderRadiusTagLarge = '1rem';
exports.SizeBorderRadiusToastBase = '0.25rem';
exports.SizeBorderRadiusTooltipBase = '0.25rem';
exports.SizeBorderRadiusDefault = '0.25rem';
exports.SizeBorderRadiusLarge = '0.5rem';
exports.SizeBorderWidthCheckboxBase = '0.0625rem';
exports.SizeBorderWidthChip = '0.0625rem';
exports.SizeBorderWidthSwitchCircleBase = '0.0625rem';
exports.SizeBorderWidthTabsBottomBase = '0.0625rem';
exports.SizeBorderWidthTabsBottomActive = '0.125rem';
exports.SizeBorderWidthDefault = '0.0625rem';
exports.SizeShadowButtonActiveHOffset = '0rem';
exports.SizeShadowButtonActiveVOffset = '0rem';
exports.SizeShadowButtonActiveBlurRadius = '0rem';
exports.SizeShadowButtonActiveSpreadRadius = '0.1875rem';
exports.SizeShadowButtonFloatingHOffset = '0rem';
exports.SizeShadowButtonFloatingVOffset = '1.125rem';
exports.SizeShadowButtonFloatingBlurRadius = '2.25rem';
exports.SizeShadowButtonFloatingSpreadRadius = '0rem';
exports.SizeShadowCheckboxHOffset = '0rem';
exports.SizeShadowCheckboxVOffset = '0rem';
exports.SizeShadowCheckboxBlurRadius = '0rem';
exports.SizeShadowCheckboxSpreadRadius = '0.125rem';
exports.SizeShadowDialogHOffset = '0rem';
exports.SizeShadowDialogVOffset = '1.125rem';
exports.SizeShadowDialogBlurRadius = '2.25rem';
exports.SizeShadowDialogSpreadRadius = '0rem';
exports.SizeShadowInputActiveHOffset = '0rem';
exports.SizeShadowInputActiveVOffset = '0rem';
exports.SizeShadowInputActiveBlurRadius = '0rem';
exports.SizeShadowInputActiveSpreadRadius = '0.1875rem';
exports.SizeShadowRadioHOffset = '0rem';
exports.SizeShadowRadioVOffset = '0rem';
exports.SizeShadowRadioBlurRadius = '0rem';
exports.SizeShadowRadioSpreadRadius = '0.125rem';
exports.SizeShadowSwitchCircleBaseHOffset = '0rem';
exports.SizeShadowSwitchCircleBaseVOffset = '0.125rem';
exports.SizeShadowSwitchCircleBaseBlurRadius = '0.25rem';
exports.SizeShadowSwitchCircleBaseSpreadRadius = '0rem';
exports.SizeShadowSwitchCircleHoverHOffset = '0rem';
exports.SizeShadowSwitchCircleHoverVOffset = '0rem';
exports.SizeShadowSwitchCircleHoverBlurRadius = '0rem';
exports.SizeShadowSwitchCircleHoverSpreadRadius = '0.1875rem';
exports.SizeShadowToastBaseHOffset = '0rem';
exports.SizeShadowToastBaseVOffset = '0.75rem';
exports.SizeShadowToastBaseBlurRadius = '1.5rem';
exports.SizeShadowToastBaseSpreadRadius = '0rem';
exports.SizeShadowTooltipDialogHOffset = '0rem';
exports.SizeShadowTooltipDialogVOffset = '0.75rem';
exports.SizeShadowTooltipDialogBlurRadius = '1.5rem';
exports.SizeShadowTooltipDialogSpreadRadius = '0rem';
exports.SizeShadowTooltipTextHOffset = '0rem';
exports.SizeShadowTooltipTextVOffset = '0.125rem';
exports.SizeShadowTooltipTextBlurRadius = '0.25rem';
exports.SizeShadowTooltipTextSpreadRadius = '0rem';
exports.SizeBorderRadiusErrorBannerBase = '0.25rem';
exports.SizeBorderRadiusNotificationBannerBase = '0.25rem';
exports.SizeBorderRadiusSkeletonSmall = '0.125rem';
exports.SizeBorderRadiusSkeletonMedium = '0.25rem';
exports.SizeIconErrorBannerMedium = '1rem';
exports.SizeIconErrorBannerHigh = '1.5rem';
exports.SizeIconNotificationBannerBase = '1.5rem';
exports.SizePositionNotificationBannerFloatingBase = '0.5rem';
exports.SizeBreakpointsXs = '0px';
exports.SizeBreakpointsS = '768px';
exports.SizeBreakpointsM = '1024px';
exports.SizeBreakpointsL = '1360px';
exports.SizeBreakpointsXl = '1600px';
exports.SizePoint11 = '0.6875rem';
exports.SizePoint12 = '0.75rem';
exports.SizePoint14 = '0.875rem';
exports.SizePoint16 = '1rem';
exports.SizePoint18 = '1.125rem';
exports.SizePoint20 = '1.25rem';
exports.SizePoint23 = '1.4375rem';
exports.SizePoint29 = '1.825rem';
exports.SizePoint32 = '2rem';
exports.SizeElevation100HOffset = '0rem';
exports.SizeElevation100VOffset = '0.125rem';
exports.SizeElevation100BlurRadius = '0.25rem';
exports.SizeElevation100SpreadRadius = '0rem';
exports.SizeElevation300HOffset = '0rem';
exports.SizeElevation300VOffset = '0.375rem';
exports.SizeElevation300BlurRadius = '0.75rem';
exports.SizeElevation300SpreadRadius = '0rem';
exports.SizeElevation600HOffset = '0rem';
exports.SizeElevation600VOffset = '0.75rem';
exports.SizeElevation600BlurRadius = '1.5rem';
exports.SizeElevation600SpreadRadius = '0rem';
exports.SizeElevation900HOffset = '0rem';
exports.SizeElevation900VOffset = '1.125rem';
exports.SizeElevation900BlurRadius = '2.25rem';
exports.SizeElevation900SpreadRadius = '0rem';
exports.SizeSpacing02 = '0.5rem';
exports.SizeSpacing04 = '1rem';
exports.SizeSpacingDefault = '0.5rem';
exports.ColorFontButtonDefaultBase = '#1454b8';
exports.ColorFontButtonDefaultDisabled = 'rgba(51, 51, 51, 0.35)';
exports.ColorFontButtonDefaultLoading = '#666666';
exports.ColorFontButtonContainedDisabled = 'rgba(51, 51, 51, 0.35)';
exports.ColorFontButtonContainedPrice = '#ffffff';
exports.ColorFontButtonContainedGrey = '#333333';
exports.ColorFontButtonContainedGreyLoading = '#333333';
exports.ColorFontButtonContainedError = '#ffffff';
exports.ColorFontButtonContainedErrorLoading = '#ffffff';
exports.ColorFontButtonContainedLoading = '#ffffff';
exports.ColorFontButtonContainedDarkBase = '#1454b8';
exports.ColorFontButtonContainedDarkDisabled = 'rgba(242, 242, 242, 0.35)';
exports.ColorFontButtonIconBase = '#1454b8';
exports.ColorFontButtonIconDisabled = 'rgba(51, 51, 51, 0.35)';
exports.ColorFontButtonIconGrey = '#666666';
exports.ColorFontButtonIconError = '#c10b3a';
exports.ColorFontButtonOutlinedBase = '#1454b8';
exports.ColorFontButtonOutlinedDisabled = 'rgba(51, 51, 51, 0.35)';
exports.ColorFontButtonOutlinedGrey = '#666666';
exports.ColorFontButtonOutlinedGreyLoading = '#666666';
exports.ColorFontButtonOutlinedError = '#c10b3a';
exports.ColorFontButtonOutlinedErrorLoading = '#c10b3a';
exports.ColorFontButtonOutlinedLoading = '#1454b8';
exports.ColorFontButtonOutlinedDarkBase = '#ffffff';
exports.ColorFontButtonOutlinedDarkDisabled = 'rgba(242, 242, 242, 0.35)';
exports.ColorFontButtonTextBase = '#1454b8';
exports.ColorFontButtonTextDisabled = 'rgba(51, 51, 51, 0.35)';
exports.ColorFontButtonTextGrey = '#666666';
exports.ColorFontButtonTextGreyLoading = '#666666';
exports.ColorFontButtonTextError = '#c10b3a';
exports.ColorFontButtonTextErrorLoading = '#c10b3a';
exports.ColorFontButtonTextLoading = '#1454b8';
exports.ColorFontCheckboxDisabled = '#cccccc';
exports.ColorFontChipBase = '#333333';
exports.ColorFontChipDisabled = 'rgba(51, 51, 51, 0.35)';
exports.ColorFontErrorBannerBase = '#333333';
exports.ColorFontInputBase = '#333333';
exports.ColorFontInputDisabled = '#cccccc';
exports.ColorFontInputLabelBase = '#666666';
exports.ColorFontInputLabelHover = '#1454b8';
exports.ColorFontInputLabelDisabled = '#cccccc';
exports.ColorFontInputLabelError = '#c10b3a';
exports.ColorFontLinkBase = '#1454b8';
exports.ColorFontLinkDarkMode = '#a3c2f5';
exports.ColorFontLinkVisited = '#1454b8';
exports.ColorFontLinkVisitedDarkMode = '#a3c2f5';
exports.ColorFontLinkActive = '#0b2e65';
exports.ColorFontLinkActiveDarkMode = '#e8f0fd';
exports.ColorFontLinkDisabled = '#cccccc';
exports.ColorFontLinkDisabledDarkMode = '#666666';
exports.ColorFontListBase = '#333333';
exports.ColorFontListGrey = '#666666';
exports.ColorFontNotificationBannerMedium = '#333333';
exports.ColorFontNotificationBannerHigh = '#ffffff';
exports.ColorFontPointsDisabled = '#cccccc';
exports.ColorFontPointsBreakdownBase = '#4d4d4d';
exports.ColorFontRadioDisabled = '#cccccc';
exports.ColorFontSegmentBase = '#666666';
exports.ColorFontSegmentHover = '#1454b8';
exports.ColorFontSegmentActive = '#1454b8';
exports.ColorFontSegmentSelected = '#1454b8';
exports.ColorFontTabsBase = '#666666';
exports.ColorFontTabsActive = '#1454b8';
exports.ColorFontTabsDisabled = '#cccccc';
exports.ColorFontTagOutlinedGrey = '#666666';
exports.ColorFontTagOutlinedSecondary = '#db5800';
exports.ColorFontTagOutlinedError = '#c10b3a';
exports.ColorFontTagOutlinedSuccess = '#2b8251';
exports.ColorFontTagContainedBase = '#ffffff';
exports.ColorFontTooltipText = '#ffffff';
exports.ColorFontTooltipDialogInvertedBg = '#ffffff';
exports.ColorFontTypographyBase = '#333333';
exports.ColorFontTypographyModeDark = '#ffffff';
exports.ColorFontDefault = '#333333';
exports.ColorFontDefaultLight = '#4d4d4d';
exports.ColorFontGrey = '#666666';
exports.ColorFontDisabled = '#666666';
exports.ColorFontDisabledLight1 = '#999999';
exports.ColorFontDisabledLight2 = '#cccccc';
exports.ColorFontDisabledLight3 = '#f2f2f2';
exports.ColorFontWhite = '#ffffff';
exports.ColorFontSuccess = '#2b8251';
exports.ColorFontSuccessLight1 = '#3fc078';
exports.ColorFontError = '#c10b3a';
exports.ColorFontPrimaryDark2 = '#0b2e65';
exports.ColorFontPrimary = '#1454b8';
exports.ColorFontPrimaryLight1 = '#2070ef';
exports.ColorFontPrimaryLight2 = '#a3c2f5';
exports.ColorFontPrimaryLight3 = '#e8f0fd';
exports.ColorFontSecondary = '#db5800';
exports.ColorFontDisabledAlpha = 'rgba(51, 51, 51, 0.35)';
exports.ColorFontDisabledDarkAlpha = 'rgba(242, 242, 242, 0.35)';
exports.ColorIconButtonDefaultBase = '#1454b8';
exports.ColorIconButtonDefaultGrey = '#666666';
exports.ColorIconButtonDefaultError = '#c10b3a';
exports.ColorIconButtonDefaultPrice = '#ffffff';
exports.ColorIconButtonContainedGrey = '#333333';
exports.ColorIconCheckboxBase = '#ffffff';
exports.ColorIconErrorBannerMedium = '#1454b8';
exports.ColorIconErrorBannerHigh = '#c10b3a';
exports.ColorIconInputBase = '#666666';
exports.ColorIconInputLabelBase = '#f2f2f2';
exports.ColorIconInputLabelSuccess = '#3fc078';
exports.ColorIconInputLabelError = '#c10b3a';
exports.ColorIconInputLabelDisabled = '#f2f2f2';
exports.ColorIconNotificationBannerMedium = '#2070ef';
exports.ColorIconNotificationBannerHigh = '#ffffff';
exports.ColorIconSwitchBase = '#999999';
exports.ColorIconSwitchLoading = '#1454b8';
exports.ColorIconSwitchChecked = '#2070ef';
exports.ColorIconSwitchDisabled = '#cccccc';
exports.ColorBackgroundButtonDefaultHover = '#e8f0fd';
exports.ColorBackgroundButtonDefaultActive = '#e8f0fd';
exports.ColorBackgroundButtonDefaultGreyActive = '#f2f2f2';
exports.ColorBackgroundButtonDefaultErrorActive = '#fee7ed';
exports.ColorBackgroundButtonDefaultDisabled = '#cccccc';
exports.ColorBackgroundButtonDefaultLoading = '#e8f0fd';
exports.ColorBackgroundButtonContainedBase = '#1454b8';
exports.ColorBackgroundButtonContainedHover = '#104393';
exports.ColorBackgroundButtonContainedActive = '#0b2e65';
exports.ColorBackgroundButtonContainedDisabled = 'rgba(102, 102, 102, 0.15)';
exports.ColorBackgroundButtonContainedGrey = '#f2f2f2';
exports.ColorBackgroundButtonContainedGreyHover = '#cccccc';
exports.ColorBackgroundButtonContainedGreyActive = '#999999';
exports.ColorBackgroundButtonContainedGreyLoading = '#cccccc';
exports.ColorBackgroundButtonContainedError = '#c10b3a';
exports.ColorBackgroundButtonContainedErrorHover = '#91082b';
exports.ColorBackgroundButtonContainedErrorActive = '#60061d';
exports.ColorBackgroundButtonContainedErrorLoading = '#91082b';
exports.ColorBackgroundButtonContainedLoading = '#104393';
exports.ColorBackgroundButtonContainedDarkBase = '#ffffff';
exports.ColorBackgroundButtonContainedDarkHover = '#e8f0fd';
exports.ColorBackgroundButtonContainedDarkActive = '#a3c2f5';
exports.ColorBackgroundButtonContainedDarkLoading = '#e8f0fd';
exports.ColorBackgroundButtonContainedDarkDisabled = 'rgba(242, 242, 242, 0.15)';
exports.ColorBackgroundButtonIconHover = '#e8f0fd';
exports.ColorBackgroundButtonIconGreyLoading = '#f2f2f2';
exports.ColorBackgroundButtonIconGreyHover = '#f2f2f2';
exports.ColorBackgroundButtonIconErrorHover = '#fee7ed';
exports.ColorBackgroundButtonIconErrorLoading = '#fee7ed';
exports.ColorBackgroundButtonIconLoading = '#e8f0fd';
exports.ColorBackgroundButtonOutlinedHover = '#e8f0fd';
exports.ColorBackgroundButtonOutlinedGreyHover = '#f2f2f2';
exports.ColorBackgroundButtonOutlinedGreyLoading = '#f2f2f2';
exports.ColorBackgroundButtonOutlinedErrorHover = '#fee7ed';
exports.ColorBackgroundButtonOutlinedErrorLoading = '#fee7ed';
exports.ColorBackgroundButtonOutlinedLoading = '#e8f0fd';
exports.ColorBackgroundButtonOutlinedDarkHover = 'rgba(255, 255, 255, 0.1)';
exports.ColorBackgroundButtonOutlinedDarkActive = 'rgba(255, 255, 255, 0.2)';
exports.ColorBackgroundButtonOutlinedDarkLoading = 'rgba(255, 255, 255, 0.1)';
exports.ColorBackgroundButtonTextHover = '#e8f0fd';
exports.ColorBackgroundButtonTextGreyHover = '#f2f2f2';
exports.ColorBackgroundButtonTextGreyLoading = '#cccccc';
exports.ColorBackgroundButtonTextErrorHover = '#fee7ed';
exports.ColorBackgroundButtonTextErrorLoading = '#fee7ed';
exports.ColorBackgroundButtonTextLoading = '#e8f0fd';
exports.ColorBackgroundCheckboxChecked = '#2070ef';
exports.ColorBackgroundCheckboxCheckedHover = '#104393';
exports.ColorBackgroundCheckboxCheckedDisabled = '#cccccc';
exports.ColorBackgroundCheckboxError = '#c10b3a';
exports.ColorBackgroundCheckboxErrorHover = '#91082b';
exports.ColorBackgroundChipDefault = '#ffffff';
exports.ColorBackgroundChipHover = '#f2f2f2';
exports.ColorBackgroundChipActive = '#e8f0fd';
exports.ColorBackgroundChipSelectedDisabled = 'rgba(102, 102, 102, 0.15)';
exports.ColorBackgroundDialogBase = '#ffffff';
exports.ColorBackgroundErrorBannerMedium = '#e8f0fd';
exports.ColorBackgroundErrorBannerHigh = '#fee7ed';
exports.ColorBackgroundInputDisabled = '#f2f2f2';
exports.ColorBackgroundListActive = '#e8f0fd';
exports.ColorBackgroundListHover = '#f2f2f2';
exports.ColorBackgroundModalBase = '#ffffff';
exports.ColorBackgroundNotificationBannerMedium = '#e8f0fd';
exports.ColorBackgroundNotificationBannerHigh = '#2070ef';
exports.ColorBackgroundNotificationBannerError = '#c10b3a';
exports.ColorBackgroundRadioChecked = '#2070ef';
exports.ColorBackgroundRadioCheckedCircle = '#ffffff';
exports.ColorBackgroundRadioCheckedHover = '#104393';
exports.ColorBackgroundRadioCheckedDisabled = '#cccccc';
exports.ColorBackgroundSegmentSelected = '#e8f0fd';
exports.ColorBackgroundSegmentActive = '#e8f0fd';
exports.ColorBackgroundSkeletonDefault = '#eaeaea';
exports.ColorBackgroundSkeletonLight = '#f6f6f6';
exports.ColorBackgroundSwitchCircleBase = '#ffffff';
exports.ColorBackgroundSwitchCircleDisabled = '#f2f2f2';
exports.ColorBackgroundSwitchTrackBase = '#cccccc';
exports.ColorBackgroundSwitchTrackLoading = '#1454b8';
exports.ColorBackgroundSwitchTrackChecked = '#2070ef';
exports.ColorBackgroundSwitchTrackDisabled = '#f2f2f2';
exports.ColorBackgroundTabsBase = '#ffffff';
exports.ColorBackgroundTabsHover = '#e8f0fd';
exports.ColorBackgroundTabsFocus = '#a3c2f5';
exports.ColorBackgroundTabsActive = '#ffffff';
exports.ColorBackgroundTabsDisabled = '#ffffff';
exports.ColorBackgroundTagOutlinedBase = '#ffffff';
exports.ColorBackgroundTagContainedGrey = '#666666';
exports.ColorBackgroundTagContainedSecondary = '#db5800';
exports.ColorBackgroundTagContainedError = '#c10b3a';
exports.ColorBackgroundTagContainedSuccess = '#2b8251';
exports.ColorBackgroundTooltipDialogBase = '#ffffff';
exports.ColorBackgroundTooltipDialogInvertedBg = '#2070ef';
exports.ColorBackgroundTooltipText = '#333333';
exports.ColorBackgroundWhite = '#ffffff';
exports.ColorBackgroundDisabled = '#f2f2f2';
exports.ColorBackgroundGrey = '#666666';
exports.ColorBackgroundGreyLight1 = '#999999';
exports.ColorBackgroundGreyLight2 = '#cccccc';
exports.ColorBackgroundGreyLight3 = '#f2f2f2';
exports.ColorBackgroundGreyDark2 = '#333333';
exports.ColorBackgroundBackDrop = 'rgba(0, 0, 0, 0.7)';
exports.ColorBackgroundSuccess = '#2b8251';
exports.ColorBackgroundErrorDark2 = '#60061d';
exports.ColorBackgroundErrorDark1 = '#91082b';
exports.ColorBackgroundError = '#c10b3a';
exports.ColorBackgroundErrorLight2 = '#f9a0b6';
exports.ColorBackgroundErrorLight3 = '#fee7ed';
exports.ColorBackgroundPrimaryDark2 = '#0b2e65';
exports.ColorBackgroundPrimaryDark1 = '#104393';
exports.ColorBackgroundPrimary = '#1454b8';
exports.ColorBackgroundPrimaryLight1 = '#2070ef';
exports.ColorBackgroundPrimaryLight2 = '#a3c2f5';
exports.ColorBackgroundPrimaryLight3 = '#e8f0fd';
exports.ColorBackgroundSecondary = '#db5800';
exports.ColorBackgroundWhiteAlpha1 = 'rgba(255, 255, 255, 0.1)';
exports.ColorBackgroundWhiteAlpha2 = 'rgba(255, 255, 255, 0.2)';
exports.ColorBackgroundDisabledAlpha = 'rgba(102, 102, 102, 0.15)';
exports.ColorBackgroundDisabledDarkAlpha = 'rgba(242, 242, 242, 0.15)';
exports.ColorShadowButtonActive = '#a3c2f5';
exports.ColorShadowButtonGreyActive = '#cccccc';
exports.ColorShadowButtonErrorActive = '#f9a0b6';
exports.ColorShadowButtonFloating = 'rgba(51, 51, 51, 0.18)';
exports.ColorShadowButtonDarkContained = '#e8f0fd';
exports.ColorShadowButtonDarkOutlined = '#ffffff';
exports.ColorShadowCheckboxHover = '#a3c2f5';
exports.ColorShadowCheckboxErrorHover = '#f9a0b6';
exports.ColorShadowDialogBase = 'rgba(51, 51, 51, 0.18)';
exports.ColorShadowInputActive = '#a3c2f5';
exports.ColorShadowInputErrorActive = '#f9a0b6';
exports.ColorShadowRadioHover = '#a3c2f5';
exports.ColorShadowSwitchCircleBase = 'rgba(51, 51, 51, 0.18)';
exports.ColorShadowSwitchCircleHover = '#a3c2f5';
exports.ColorShadowToastBase = 'rgba(51, 51, 51, 0.18)';
exports.ColorShadowTooltipDialog = 'rgba(51, 51, 51, 0.18)';
exports.ColorShadowTooltipText = 'rgba(51, 51, 51, 0.18)';
exports.ColorBorderButtonOutlinedBase = '#1454b8';
exports.ColorBorderButtonOutlinedGrey = '#999999';
exports.ColorBorderButtonOutlinedError = '#c10b3a';
exports.ColorBorderButtonOutlinedDisabled = 'rgba(102, 102, 102, 0.25)';
exports.ColorBorderButtonOutlinedLoading = '#1454b8';
exports.ColorBorderButtonOutlinedDarkBase = '#ffffff';
exports.ColorBorderButtonOutlinedDarkDisabled = 'rgba(242, 242, 242, 0.25)';
exports.ColorBorderCheckboxBase = '#999999';
exports.ColorBorderCheckboxChecked = '#2070ef';
exports.ColorBorderCheckboxCheckedHover = '#104393';
exports.ColorBorderCheckboxDisabled = '#cccccc';
exports.ColorBorderCheckboxDisabledHover = '#cccccc';
exports.ColorBorderCheckboxHover = '#2070ef';
exports.ColorBorderCheckboxError = '#c10b3a';
exports.ColorBorderCheckboxErrorHover = '#91082b';
exports.ColorBorderChipDefault = '#cccccc';
exports.ColorBorderChipActive = '#1454b8';
exports.ColorBorderChipDisabled = 'rgba(102, 102, 102, 0.25)';
exports.ColorBorderInputBase = '#666666';
exports.ColorBorderInputHover = '#1454b8';
exports.ColorBorderInputActive = '#1454b8';
exports.ColorBorderInputDisabled = '#f2f2f2';
exports.ColorBorderRadioBase = '#999999';
exports.ColorBorderRadioChecked = '#2070ef';
exports.ColorBorderRadioCheckedHover = '#104393';
exports.ColorBorderRadioDisabled = '#cccccc';
exports.ColorBorderRadioDisabledHover = '#cccccc';
exports.ColorBorderRadioHover = '#2070ef';
exports.ColorBorderSegmentBase = '#999999';
exports.ColorBorderSegmentHover = '#1454b8';
exports.ColorBorderSegmentActive = '#1454b8';
exports.ColorBorderSegmentSelected = '#1454b8';
exports.ColorBorderSwitchCircleBase = '#f2f2f2';
exports.ColorBorderTabsBase = '#cccccc';
exports.ColorBorderTabsActive = '#1454b8';
exports.ColorBorderTagOutlinedGrey = '#666666';
exports.ColorBorderTagOutlinedSecondary = '#db5800';
exports.ColorBorderTagOutlinedError = '#c10b3a';
exports.ColorBorderTagOutlinedSuccess = '#2b8251';
exports.ColorBorderDisabled = '#666666';
exports.ColorBorderGrey = '#666666';
exports.ColorBorderDisabledLight1 = '#999999';
exports.ColorBorderDisabledLight2 = '#cccccc';
exports.ColorBorderDisabledLight3 = '#f2f2f2';
exports.ColorBorderSuccess = '#2b8251';
exports.ColorBorderError = '#c10b3a';
exports.ColorBorderPrimary = '#1454b8';
exports.ColorBorderPrimaryDark1 = '#104393';
exports.ColorBorderPrimaryLight1 = '#2070ef';
exports.ColorBorderSecondary = '#db5800';
exports.ColorBorderDisabledAlpha = 'rgba(102, 102, 102, 0.25)';
exports.ColorBorderDisabledDarkAlpha = 'rgba(242, 242, 242, 0.25)';
exports.ColorLinkErrorBannerMedium = '#1454b8';
exports.ColorLinkErrorBannerHigh = '#c10b3a';
exports.ColorUnderlineLinkHover = '#1454b8';
exports.ColorUnderlineLinkHoverDarkMode = '#a3c2f5';
exports.ColorUnderlineLinkActive = '#0b2e65';
exports.ColorUnderlineLinkActiveDarkMode = '#e8f0fd';
exports.ColorBaseMineShaft700 = '#333333';
exports.ColorBaseMineShaft600 = '#4d4d4d';
exports.ColorBaseMineShaft500 = '#666666';
exports.ColorBaseMineShaft300 = '#999999';
exports.ColorBaseMineShaft100 = '#cccccc';
exports.ColorBaseMineShaft80 = '#eaeaea';
exports.ColorBaseMineShaft50 = '#f2f2f2';
exports.ColorBaseMineShaft40 = '#f6f6f6';
exports.ColorBaseShiraz700 = '#60061d';
exports.ColorBaseShiraz600 = '#91082b';
exports.ColorBaseShiraz500 = '#c10b3a';
exports.ColorBaseShiraz300 = '#f43e6d';
exports.ColorBaseShiraz100 = '#f9a0b6';
exports.ColorBaseShiraz50 = '#fee7ed';
exports.ColorBaseGreenPea700 = '#0d2618';
exports.ColorBaseGreenPea600 = '#194d30';
exports.ColorBaseGreenPea500 = '#2b8251';
exports.ColorBaseGreenPea300 = '#3fc078';
exports.ColorBaseGreenPea100 = '#8cd9ae';
exports.ColorBaseGreenPea50 = '#dcf5e7';
exports.ColorBaseBrandPrimary700 = '#0b2e65';
exports.ColorBaseBrandPrimary600 = '#104393';
exports.ColorBaseBrandPrimary500 = '#1454b8';
exports.ColorBaseBrandPrimary300 = '#2070ef';
exports.ColorBaseBrandPrimary100 = '#a3c2f5';
exports.ColorBaseBrandPrimary50 = '#e8f0fd';
exports.ColorBaseBrandSecondary700 = '#662a00';
exports.ColorBaseBrandSecondary600 = '#994000';
exports.ColorBaseBrandSecondary500 = '#db5800';
exports.ColorBaseBrandSecondary300 = '#ff8833';
exports.ColorBaseBrandSecondary100 = '#ffc499';
exports.ColorBaseBrandSecondary50 = '#fff0e5';
exports.ColorBasePrimary40 = '#f9f4fb';
exports.ColorBaseWhite = '#ffffff';
exports.ColorElevation100 = 'rgba(51, 51, 51, 0.18)';
exports.ColorElevation300 = 'rgba(51, 51, 51, 0.18)';
exports.ColorElevation600 = 'rgba(51, 51, 51, 0.18)';
exports.ColorElevation900 = 'rgba(51, 51, 51, 0.18)';
exports.ContentFontWeightButtonDefault = '700';
exports.ContentFontWeightButtonContainedPrice = '900';
exports.ContentFontWeightPointsBase = '400';
exports.ContentFontWeightSegmentBase = '400';
exports.ContentFontWeightSegmentSelected = '700';
exports.ContentFontWeightTagBase = '400';
exports.ContentFontWeightTypographyH1 = '900';
exports.ContentFontWeightTypographyH2 = '700';
exports.ContentFontWeightTypographyH3 = '700';
exports.ContentFontWeightTypographyH4 = '700';
exports.ContentFontWeightTypographyH5 = '700';
exports.ContentFontWeightTypographyH6 = '700';
exports.ContentFontWeightTypographySubhead1 = '700';
exports.ContentFontWeightTypographySubhead2 = '700';
exports.ContentFontWeightTypographyPrice1 = '900';
exports.ContentFontWeightTypographyPrice2 = '900';
exports.ContentFontWeightTypographyPrice3 = '900';
exports.ContentFontWeightTypographyPrice4 = '900';
exports.ContentFontWeightTypographyTitleXxl = '700';
exports.ContentFontWeightTypographyTitleXl = '700';
exports.ContentFontWeightTypographyTitleL = '700';
exports.ContentFontWeightTypographyTitleM = '700';
exports.ContentFontWeightTypographyTitleS = '700';
exports.ContentFontWeightTypographyTitleXs = '700';
exports.ContentFontWeightTypographyBodyLBold = '700';
exports.ContentFontWeightTypographyBodyLRegular = '400';
exports.ContentFontWeightTypographyBodyMBold = '700';
exports.ContentFontWeightTypographyBodyM = '400';
exports.ContentFontWeightTypographyBodySBold = '700';
exports.ContentFontWeightTypographyBodyS = '400';
exports.ContentFontWeightTypographyCaption1Regular = '400';
exports.ContentFontWeightTypographyCaption1Bold = '700';
exports.ContentFontWeightTypographyCaption2Regular = '400';
exports.ContentFontWeightTypographyCaption2Bold = '700';
exports.ContentFontWeightTypographyPriceXl = '900';
exports.ContentFontWeightTypographyPriceL = '900';
exports.ContentFontWeightTypographyPriceM = '900';
exports.ContentFontWeightTypographyPriceS = '900';
exports.ContentFontWeightTypographyPriceXs = '900';
exports.ContentFontWeightTypographyPriceXxs = '900';
exports.ContentFontWeightNormal = '400';
exports.ContentFontWeightBold = '700';
exports.ContentFontWeightBlack = '900';
exports.FontFamilyBase = '"Lato",sans-serif';
//# sourceMappingURL=tokens.js.map